<template>
    <div>
        <div v-if="message !== ''" :class="'notification animated ' + current_animation + ' ' + type">
            <span>{{ message }}</span>
        </div>
        <div v-show="message === ''" style="opacity:0;">
            <span></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        message: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: "error"
        }
    },
    data() {
        return {
            current_animation: ""
        }
    },
    watch: {
        message() {
            this.current_animation = "fadeIn";
            setTimeout(function () {
                this.current_animation = "fadeOut";
            }.bind(this), 3000);
        }
    }
}
</script>

<style scoped>
.notification {
    margin: 10px;
    border-radius: 10px;
    padding: 5px;
}
.error {
    background: red; 
    color: white;
}
.success {
    background: green;
    color: white;
}
</style>